import { inject, Injectable, signal } from '@angular/core';
import { finalize, tap } from 'rxjs';

import { ProfileService } from '@tfs/auth';
import { ProfileApi } from '@tfs/tool-library-library-api';

import { MeasurementSystemDto, OnboardingStatusDto } from '../models/user-onboarding-modal.models';

@Injectable({
  providedIn: 'root',
})
export class UserOnboardingProfileDataStore {
  readonly isLoading = signal<boolean>(false);

  private readonly profileApi = inject(ProfileApi);
  private readonly profileService = inject(ProfileService);

  updateMeasurementSystem(measurementSystem: MeasurementSystemDto) {
    this.isLoading.set(true);
    return this.profileApi.updateProfile({ measurementSystem }).pipe(
      tap(() => this.patchProfile({ measurementSystem })),
      finalize(() => this.isLoading.set(false))
    );
  }

  updateStatusDateFormat(onboardingStatus: OnboardingStatusDto, dateFormat: string) {
    this.isLoading.set(true);
    return this.profileApi.updateProfile({ onboardingStatus, dateFormat }).pipe(
      tap(() => this.patchProfile({ onboardingStatus, dateFormat })),
      finalize(() => this.isLoading.set(false))
    );
  }

  updateOnboardingStatus(onboardingStatus: OnboardingStatusDto) {
    this.isLoading.set(true);
    return this.profileApi.updateProfile({ onboardingStatus }).pipe(
      tap(() => this.patchProfile({ onboardingStatus })),
      finalize(() => this.isLoading.set(false))
    );
  }

  updateDateFormat(dateFormat: string) {
    this.isLoading.set(true);
    return this.profileApi.updateProfile({ dateFormat }).pipe(
      tap(() => this.patchProfile({ dateFormat })),
      finalize(() => this.isLoading.set(false))
    );
  }

  private patchProfile(patch: {
    measurementSystem?: MeasurementSystemDto;
    onboardingStatus?: OnboardingStatusDto;
    dateFormat?: string;
  }): void {
    const currentProfile = this.profileService.userProfile();
    if (!currentProfile) return;
    this.profileService.setUserProfile({ ...currentProfile, ...patch });
  }
}
